/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useContext } from "react"
import { useDrop } from "react-dnd"
import { T配車, T車輌乗務員 } from "../../../../service/order/haisya/THaisya"
import { ItemType } from "../HaisyaRegister"
import {
  ZyomuinListContext,
  SearchConditionContext,
  MihaisyaListContext,
  CalenderSearchContext,
  MihaisyaSearchContext,
} from "../HaisyaContext"
import { AppDispatch } from "../../../.."
import { useDispatch, useSelector } from "react-redux"
import { set配送順 } from "../haisyaRegisterUtil"
import dayjs from "dayjs"
import { showWarningToast } from "../../../../components/CustomToast"
import { setAlerts } from "../../../../globalStore/alertStore"
import { RootState } from "../../../../globalStore/rootreducer"

const OneDayHaisyaTableCell: React.FC<{
  haisoNo: number
  zyomuin: T車輌乗務員

  tumibi: string
  className?: string
  onClick?: React.MouseEventHandler<HTMLDivElement>
}> = (props) => {
  const { eigyobiStr: 営業日 } = useSelector((state: RootState) => state.date)
  const { 車輌乗務員List, set車輌乗務員List } = useContext(ZyomuinListContext)
  const { set未配車List } = useContext(MihaisyaListContext)
  const searchCondition = useContext(SearchConditionContext)
  const dispatch: AppDispatch = useDispatch()
  const calenderSearch = useContext(CalenderSearchContext)
  const mihaisyaSearch = useContext(MihaisyaSearchContext)

  const dropFunction = useCallback(
    async (item: T配車, monitor) => {
      let 配送順 = props.haisoNo
      const セル積日 = dayjs(props.tumibi)
      const 配車積日 = dayjs(item.積日)
      const 対象積日受注配車個数 = props.zyomuin.受注配車.filter((z) =>
        dayjs(z.積日).isSame(セル積日, "d")
      ).length

      // 過去日付はそもそも登録できないようにする
      if (
        !セル積日.isSame(dayjs(営業日), "d") &&
        セル積日.isBefore(dayjs(営業日), "d")
      ) {
        showWarningToast("営業日以前の運行は登録できません。")
        return
      }

      if (
        item.乗務員ID === props.zyomuin.乗務員ID &&
        item.車輌ID === props.zyomuin.車輌ID
      ) {
        //配車の乗務員と車輌IDおよび  配送順が一致している場合、処理を行わない
        if (item.配送順 === 配送順) {
          return
        }

        // 同一列かつ配車済での配送順変更時に個数以上の配送順のセルにドロップした場合、最大値として登録する。自分が最大値の場合は処理を行わない
        if (item.積日 != null && item.積日 !== "") {
          if (セル積日.isSame(配車積日, "d")) {
            if (props.haisoNo >= 対象積日受注配車個数) {
              if (対象積日受注配車個数 === item.配送順) {
                return
              }
              // else {
              //   配送順 = 対象積日受注配車個数 === 0 ? 1 : 対象積日受注配車個数
              // }
            }
          }
        }
      } else {
        if (対象積日受注配車個数 >= 8) {
          // 8配車以上は登録不可
          showWarningToast("9件以上の運行は登録できません。")
          return
        }

        // 別列の場合は配送順のみ確認する
        // if (props.haisoNo >= 対象積日受注配車個数) {
        //   配送順 = 対象積日受注配車個数 === 0 ? 1 : 対象積日受注配車個数 + 1
        // }
      }

      try {
        const res = await set配送順({
          dispatch,
          searchCondition,
          set未配車List,
          set車輌乗務員List,
          乗務員: props.zyomuin,
          積日: props.tumibi,
          配車: item,
          配送順,
        })
        if (res) {
          await calenderSearch()
          await mihaisyaSearch()
        }
      } catch (error) {
        dispatch(setAlerts(error))
      }
    },
    [
      props.haisoNo,
      props.zyomuin.乗務員ID,
      props.zyomuin.車番,
      searchCondition?.積日,
      set車輌乗務員List,
      車輌乗務員List,
    ]
  )

  const [, dropRef] = useDrop(
    () => ({
      accept: ItemType.配車,
      drop: dropFunction,
    }),
    [車輌乗務員List, props.zyomuin]
  )
  return (
    <td className={props.className} ref={dropRef}>
      <div onClick={props.onClick} className="w-100 h-100">
        {props.children}
      </div>
    </td>
  )
}

export default OneDayHaisyaTableCell
